module.exports = __webpack_public_path__ + "static/media/Down.344076f7.svg";